import RequestToken from '../../../../tokens/RequestToken';
import {CommandRequester} from '../../../../CommandRequester';
import RequestAPI from '../../../RequestAPI';
import {CommandTypes, PhotoEvents, ResponseCode} from '@jibo/command-protocol';


/**
 * @class PhotoToken
 * @extends RequestToken
 * @hideconstructor
 */
export class PhotoToken extends RequestToken<JIBO.v1.TakePhotoRequest, JIBO.v1.TakePhotoEvent> {

    /** @private */
    constructor(owner:CommandRequester, protocol: JIBO.v1.TakePhotoRequest) {
        super(owner, protocol);
    }

    /**
     * @private
     */
    public handleAck(ack:JIBO.v1.Acknowledgement) {
        //handle ack
        if (ack.Response.ResponseCode >= ResponseCode.BadRequest) {
            this.isComplete = true;
            this._complete.reject(ack.Response);
            return;
        }
    }

    /**
     * @private
     */
    public handleEvent(event:JIBO.v1.EventMessage) {
        //handle response
        const message = event.EventBody;
        if (message.Event === PhotoEvents.TakePhoto) {
            this.isComplete = true;
            this._complete.resolve(message);
        }
    }
}

/**
 * Internal Photo class
 * @class CommandRequester.media.capture.Photo
 * @intdocs
 */
export class Photo extends RequestAPI<JIBO.v1.TakePhotoRequest, PhotoToken> {

    /**
     * Generate Photo Protocol
     * @method CommandRequester.media.capture.Photo#generateProtocol
     * @param {Camera} [camera=left] - Which camera to use -- left or right.
     * @param {CameraResolution} [resolution=LowRes] - Choose a resolution.
     * @param {boolean} [removeDistortion=true] - Use `false` for fisheye lense.
     * @returns {TakePhotoRequest}
     * @intdocs
     */
    static generateProtocol(
        camera:JIBO.v1.Cameras.CameraType = 'left',
        resolution:JIBO.v1.CameraResolutions.CameraResolutionType = 'lowRes',
        removeDistortion = true): JIBO.v1.TakePhotoRequest {
        return {
            Type: CommandTypes.TakePhoto,
            Resolution: resolution,
            Camera: camera,
            Distortion: removeDistortion
        };
    }

    /**
     * Create PhotoToken from TakePhotoRequest protocol.
     * @method CommandRequester.media.capture.Photo#generateToken
     * @param {TakePhotoRequest} protocol - TakePhotoRequest protocol to generate a PhotoToken from.
     * @param {boolean} [andSend=false] - `true` if the generated PhotoToken should also be sent as a request.
     * @return {PhotoToken}
     * @intdocs
     */
    public generateToken(protocol: JIBO.v1.TakePhotoRequest, andSend=false): PhotoToken {
        const token = new PhotoToken(this.owner, protocol);
        if (andSend) {
            super.sendToken(token);
        }
        return token;
    }
}
